import moment from 'moment';

export const getAge = (date) => {
    return moment().diff(moment(moment(date).format("DD/MM/YYYY"), "DD/MM/YYYY"), 'years');
}